<div class="container row a_center" [ngClass]="{'show': selectedItems.length>0}">
    <div class="item">
        <span class="content_s">{{getItemsLength()}} {{getType()}} selected</span>
    </div>
    <div class="item row">
        <app-button-secondary *ngFor="let i of model" (click)="i.function(selectedItems)" [isWhite]="true" [isText]="true" [buttonText]="i.btnText" [imgUrl]="i.imgUrl"></app-button-secondary>
    </div>
</div>